import { abTestsRouteDescriptors } from '~/modules/ab-tests';
import { courseRouteDescriptors } from '~/modules/course';
import { errorRouteDescriptors } from '~/modules/errorpages/ServerError';
import { experienceRouteDescriptors } from '~/modules/experience';
import { experiencesRouteDescriptors } from '~/modules/experiences';
import { favoritesRouteDescriptors } from '~/modules/favorites';
import { featureFlagsRouteDescriptors } from '~/modules/feature-flags';
import { homescreenRouteDescriptors } from '~/modules/homescreen';
import { hostRouteDescriptors } from '~/modules/host';
import { hostAgendaRouteDescriptors } from '~/modules/host-agenda';
import { hostExperiencesRouteDescriptors } from '~/modules/host-experiences';
import { hostHomescreenRouteDescriptors } from '~/modules/host-homescreen';
import { hostLearningCenterRouteDescriptors } from '~/modules/host-learning-center';
import { hostOnboardingRouteDescriptors } from '~/modules/host-onboarding';
import { hostPayoutRouteDescriptors } from '~/modules/host-payout-methods';
import { hostPersonalizedOfferRouteDescriptors } from '~/modules/host-personalized-offer';
import { hostProfileRouteDescriptors } from '~/modules/host-profile';
import { hostTransferBookingRouteDescriptors } from '~/modules/host-transfer-booking';
import { infoPagesRouteDescriptors } from '~/modules/info-pages';
import { inviteRouteDescriptors } from '~/modules/invite';
import { appPromoRouteDescriptors } from '~/modules/landings/app-promo';
import { sustainabilityRouteDescriptors } from '~/modules/landings/sustainability';
import { localsRouteDescriptors } from '~/modules/locals';
import { manageBookingRouteDescriptors } from '~/modules/manage-booking';
import { reviewPageRouteDescriptors } from '~/modules/review-page';
import { searchRouteDescriptors } from '~/modules/search';
import { userEnvironmentRouteDescriptors } from '~/modules/user-environment2';
import { writeReviewRouteDescriptors } from '~/modules/write-review';

import type { RouteDescriptor, RouteSummary } from './types';

const DESCRIPTOR_GROUPS: RouteDescriptor[][] = [
  abTestsRouteDescriptors,
  courseRouteDescriptors,
  errorRouteDescriptors,
  experiencesRouteDescriptors,
  experienceRouteDescriptors,
  favoritesRouteDescriptors,
  featureFlagsRouteDescriptors,
  homescreenRouteDescriptors,
  hostHomescreenRouteDescriptors,
  hostLearningCenterRouteDescriptors,
  hostOnboardingRouteDescriptors,
  hostAgendaRouteDescriptors,
  hostExperiencesRouteDescriptors,
  hostTransferBookingRouteDescriptors,
  hostPayoutRouteDescriptors,
  hostPersonalizedOfferRouteDescriptors,
  hostRouteDescriptors,
  hostProfileRouteDescriptors,
  infoPagesRouteDescriptors,
  inviteRouteDescriptors,
  localsRouteDescriptors,
  manageBookingRouteDescriptors,
  searchRouteDescriptors,
  appPromoRouteDescriptors,
  sustainabilityRouteDescriptors,
  writeReviewRouteDescriptors,
  reviewPageRouteDescriptors,
  userEnvironmentRouteDescriptors,
];

export const ROUTE_LIST: RouteDescriptor[] = DESCRIPTOR_GROUPS.flat();

export type RouteId = (typeof ROUTE_LIST)[number]['id'];
export type RouteKey = RouteId;

export const ROUTES = Object.freeze(
  ROUTE_LIST.reduce(
    (acc, descriptor) => {
      acc[descriptor.id as RouteId] = descriptor;
      return acc;
    },
    {} as Record<RouteId, RouteDescriptor>,
  ),
);

export const buildRouteSummary = (): RouteSummary[] =>
  ROUTE_LIST.map(({ id, path, audience, layout, modal }) => ({
    id,
    path,
    audience,
    layout,
    modal: modal ?? false,
  }));
